import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

export function Header() {
  const { currentUser, logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    try {
      await logout()
      navigate('/signin')
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  return (
    <header className="bg-dark-card border-b border-gray-700">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <h1 className="text-xl font-bold">Progressive Overload</h1>
        {currentUser && (
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-400">{currentUser.email}</span>
            <button
              onClick={handleLogout}
              className="btn btn-secondary text-sm"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  )
}
